import { ON_CALL_SAVED_THIRD_PARTY } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageOnCallSavedThirdParty(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: ON_CALL_SAVED_THIRD_PARTY,
      data
    });
  }
}